import React, { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { primary } from "../../constants/theme";
import { sendAnalytics } from "../../utils/analyticsCommon";
import PricingImageGallery from "./PricingImageGallery";
import PricingVehicleDetails from "./PricingVehicleDetails";

// Tailwind-based lead capture layout for Pricing page
const PricingLeadCapture = ({
  vehicleDataLocal = [],
  location = "",
  minPrice = "",
  maxPrice = "",
  selectCityConfig = null,
  heading = null,
  isMobile = false,
}) => {
  const [vehicleData] = useState(
    Array.isArray(vehicleDataLocal) ? vehicleDataLocal[0] : null
  );

  const productList = Array.isArray(vehicleData?.ProductImages)
    ? vehicleData.ProductImages
    : [];
  const firstProduct = productList.length > 0 ? productList[0] : null;

  useEffect(() => {
    if (vehicleData?.name?.length > 0) {
      const payload = {
        screen_name: "pricing_page_vehicle_booking",
        vehicle_id: vehicleData?.vehicle_id,
        vehicle_name: vehicleData?.name,
      };
      sendAnalytics("screen_viewed", payload, "en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicleData]);

  if (!vehicleData) {
    return null;
  }

  const showSelectCityMobile = selectCityConfig && typeof selectCityConfig.formatCityDisplay === "function";

  return (
    <div className="relative w-full md:w-[84%] mx-auto pt-1 pb-6 md:pt-6 md:pb-9 md:px-0">
      <div className="bg-white rounded-none md:rounded-2xl p-0 md:pl-0 md:pr-6 md:py-6 flex flex-col md:flex-row gap-0 md:gap-6">
        {isMobile && heading && (
          <div className="md:hidden px-0 pb-2 px-4">
            <h1 className="text-[22px] font-bold text-gray-900">
              {heading}
            </h1>
          </div>
        )}
        {/* Gallery: full width of column, height from aspect-ratio inside */}
        <div className="relative w-full md:w-3/5 min-w-0 min-h-0 flex-shrink-0">
          {showSelectCityMobile && (
            <button
              type="button"
              onClick={selectCityConfig.onOpenModal}
              className="md:hidden absolute top-3 right-3 z-10 inline-flex items-center gap-1 px-3 py-2 rounded-full text-sm font-medium shadow-sm focus:outline-none focus:ring-2 focus:ring-[#024670] focus:ring-offset-2 touch-manipulation min-h-[40px]"
              style={{
                background: primary?.lightPink,
                color: primary?.mainText,
              }}
              aria-haspopup="dialog"
              aria-expanded={selectCityConfig.cityModalOpen}
              aria-label={`Change city, current: ${selectCityConfig.formatCityDisplay(selectCityConfig.citySlug)}`}
            >
              {selectCityConfig.formatCityDisplay(selectCityConfig.citySlug)}
              <ExpandMoreIcon sx={{ fontSize: 20, color: primary?.main }} />
            </button>
          )}
          <PricingImageGallery
            imagesDesktop={firstProduct?.imagesDesktop}
            imagesMobile={firstProduct?.imagesMobile}
            altText={vehicleData?.name}
          />
        </div>
        <div className="w-full md:w-2/5 px-4 pt-4 pb-4 md:px-0 md:pt-0 md:pb-0">
          <PricingVehicleDetails
            vehicleData={vehicleData}
            productType={firstProduct}
            location={location}
            minPrice={minPrice}
            maxPrice={maxPrice}
          />
        </div>
      </div>
    </div>
  );
};

export const MemoizedPricingLeadCapture = React.memo(PricingLeadCapture);

